<template>
  <a
    :href="directionsMapLink"
    target="_blank"
    class="button outline square minimal sml"
    ><img
      class="icon"
      src="@/assets/images/google-maps-icon.svg"
      width="17"
      height="24"
      alt=""
    />
    <translate>Directions</translate>
  </a>
</template>

<script lang="ts">
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'
import googleMap from '~/utility/google-map'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class DirectionsButton extends Vue {
  @Prop({ required: true })
  point: string

  @Prop({ required: true })
  name: string

  @Prop({ required: true })
  address: string

  get directionsMapLink() {
    const point = getPointFromStringOrDefault(this.point)
    return googleMap.googleMapLink(
      point.lat,
      point.lng,
      this.name,
      this.address,
    )
  }
}

export default toNative(DirectionsButton)
</script>
<style scoped>
a {
  display: inline-flex;
  align-items: center;
  background: white;
  flex-wrap: wrap;
  gap: 0.35em;
}

.icon {
  margin: -0.3em 0 -0.3em -0.1em;
}
</style>
